<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="新增旁站" left-text="返回" left-arrow @click-left="goBack">
			</van-nav-bar>
		</div>		
		<van-form @submit="onSubmit">
			<van-cell-group>
				<van-field readonly clickable
					:value="subjectMatter"
					name="subjectMatter" 
					label="标的物" 
					placeholder="请选择标的物"
					:rules="[{ required: true, message: '' }]"
					@click="showSubjectMatterPicker = true" />
				<van-popup v-model="showSubjectMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="subjectMatterList" value-key="displayName" @confirm="selSubjectMatter" @cancel="showSubjectMatterPicker = false" />
				</van-popup>
				<van-field
					v-model="onsiteItem"
					name="onsiteItem"
					label="项目"
					placeholder="请输入项目"
					:rules="[{ required: true, message: '' }]"
				/>
				<van-field
					v-model="onsitePosition"
					name="onsitePosition"
					label="部位"
					placeholder="请输入部位"
					:rules="[{ required: true, message: '' }]"
				/>
				<van-field readonly clickable
				  :value="beginTime"
				  name="beginTime"
				  label="开始时间"
				  placeholder="请选择开始时间"
				  :rules="[{ required: true, message: '' }]"
				  @click="showDateCalendar = true"
				/>
				<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa" @confirm="selDateCalendar" />
				<van-field
					class="textareaField"
					v-model="onsiteContent"
					type="textarea"
					name="onsiteContent"
					label="旁站内容"
					placeholder="请输入旁站内容"
					:rules="[{ required: true, message: '' }]"
				/>
			</van-cell-group>
			<van-cell-group style="margin-top: 13px;">
				<van-field
					v-model="bystander"
					name="bystander"
					label="旁站人"
					placeholder="请输入旁站人"
					:rules="[{ required: true, message: '' }]"
				/>
				<van-field
					v-model="participants"
					name="participants"
					label="参与人"
					placeholder="请输入参与人"
					:rules="[{ required: true, message: '' }]"
				/>
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>
		
	</div>
</template>
<script>
	import { save } from '../../api/safeStation'
	import { getSubjectDropDown } from '../../api/commonApi'
	import { Notify } from 'vant';
	import common from '../../utils/common';

	export default {
		name: 'safeSideStationAdd',
		data() {
			return {
				subjectMatter: "",
				subjectMatterId: "",
				showSubjectMatterPicker: false,
				// 模拟数据
				subjectMatterList: [
				],
				onsiteItem: "",
				onsitePosition: "",
				beginTime: "",
				showDateCalendar: false,
				onsiteContent: "",
				// 旁站人
				bystander: "",
				// 参与人
				participants: "",
				minDate: new Date(new Date().getFullYear()-2, 0, 1,0,0,0),
				maxDate: new Date(new Date().getFullYear()+2, 11, 31,23,59,59),
			}
		},
		mounted() {
			this.project = common.getProject();
			if(this.project == null || this.project == undefined || !this.project.workNo){
				Notify({ type: 'danger', message: '获取工作控制号失败' });
			}
			this.doGetSubjectDropDown()
		},
		methods: {
			// 标的物
			doGetSubjectDropDown() {
				getSubjectDropDown(this.project.workNo).then(response => {
					this.subjectMatterList = response.data.body
				})
			},
			goBack() {
				this.$router.push({
					name: 'safeSideStationList'
				});
			},
			selSubjectMatter(data) {
			    this.subjectMatter = data.displayName;
				this.subjectMatterId = data.displayValue;
			    this.showSubjectMatterPicker = false;
			},
			selDateCalendar(date){
				this.beginTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
				this.showDateCalendar = false;
			},
			onSubmit(data) {
				if (!common.hasPermision("station:add:2")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				const param = {
					t: new Date().getTime(),
					workNo: this.project.workNo,
					recId: 0,
					subjectNo: this.subjectMatterId,
					participants: this.participants,
					onsitePosition: this.onsitePosition,
					onsiteItem: this.onsiteItem,
					onsiteContent: this.onsiteContent,
					bystander: this.bystander,
					beginTime: this.beginTime,
					// 范畴。质量：1 ； 安全：2； 进度：3
					category: "2",
				}
				save(param).then(response => {
					if (response.data.resultCode === 200){
						Notify({ type: 'success', message: '操作成功' });
						this.goBack()
					} else {
						Notify({ type: 'danger', message: response.data.resultMessage });
					}
				})
			},
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>